module.exports = __webpack_public_path__ + "img/emotion-finger-up.7e9df7d9.svg";